"use strict";
/**
 * =================================
 * フォント関連 設定
 * =================================
 */
const defaultTheme = require('tailwindcss/defaultTheme');
/**
 * ---------------------------------
 * fontFamily
 * ---------------------------------
 */
const fontFamily = {
    alpha: ['"Roboto Condensed"', ...defaultTheme.fontFamily.sans],
    display: ['"Noto Sans JP"', ...defaultTheme.fontFamily.sans],
    serif: ['"Noto Serif JP"', ...defaultTheme.fontFamily.serif],
};
/**
 * ---------------------------------
 * fontSize [fontSize, lineHeight]
 * ---------------------------------
 */
const fontSize = {
    0: ['0px'],
    11: ['11px', '1.5'],
    13: ['13px', '1.5'],
    15: ['15px', '1.5'],
    16: ['16px', '1.5'],
    18: ['18px', '1.5'],
    20: ['20px', '1.5'],
    22: ['22px', '1.5'],
    25: ['25px', '1.5'],
    28: ['28px', '1.5'],
    34: ['34px', '1.5'],
    transparent: 'transparent',
};
// WARNING: 基本はテキストコンポーネントを使用してください
const extendFontSize = {
    'head-lg': fontSize['22'],
    'head-md': fontSize['20'],
    'head-sm': fontSize['18'],
    'head-xl': fontSize['25'],
    'head-xs': fontSize['15'],
    'head-xxl': fontSize['28'],
    'head-xxs': fontSize['13'],
    'head-xxxl': fontSize['34'],
    'text-lg': fontSize['18'],
    'text-md': fontSize['15'],
    'text-sm': fontSize['13'],
    'text-xs': fontSize['11'],
};
/**
 * ---------------------------------
 * fontWeight
 * ---------------------------------
 */
const fontWeight = {
    bold: 700,
    // NOTE: デフォルト設定値と同じですが、スタイル統一のため項目制限
    normal: 400,
};
module.exports = {
    extend: {
        fontSize: extendFontSize,
    },
    fontFamily,
    fontSize,
    fontWeight,
};
